var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "title" },
        [
          _c("v-icon", { staticClass: "mr-2" }, [_vm._v("link")]),
          _vm._v(" "),
          _c("div", [_vm._v("Linked Services")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("div", [
            _vm._v(
              "\n      These service links are used throughout the UI and must be linked to a service. If they are not linked they will not function properly.\n    "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.serviceLinks, function (link, index) {
            return _c(
              "v-chip",
              { key: `missing-link-${index}`, attrs: { small: "" } },
              [
                _c("v-icon", {
                  staticClass: "mr-1",
                  attrs: { color: link.ServiceId ? "success" : "error" },
                  domProps: {
                    innerHTML: _vm._s(link.ServiceId ? "done" : "clear"),
                  },
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.splitCapitalizeByChar(link.ServiceLink, "_")) +
                    "\n    "
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }